import { render, staticRenderFns } from "./CustomCombobox.vue?vue&type=template&id=6241004e&scoped=true"
import script from "./CustomCombobox.vue?vue&type=script&lang=js"
export * from "./CustomCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241004e",
  null
  
)

export default component.exports